import storageUtil from "../../utils/storageUtil";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LaunchScreen = () => {
  const navigation = useNavigate();

  useEffect(() => {
    const init = async () => {
      const credential: any = await storageUtil.getItem("CREDENTIAL", true);
      if (credential && credential.accessToken) {
        navigation("/workspace");
      } else {
        navigation("/index");
      }
    };
    init();
  }, [navigation]);

  return null;
};

export default LaunchScreen;
